import React, { useState } from "react";
import { AiOutlineTag } from "react-icons/ai";
import { MdLocationPin } from "react-icons/md";
import { RiPriceTag2Line } from "react-icons/ri";
import { Link, useNavigate } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import { renderItemSinglePath } from "../../../Common/Function";
import Loading from "../../../Common/Loading";

const MainItems = ({ data, types, landingLoading }) => {
  const [type, setType] = useState("special_offers");
  const renderTypeName = ele => {
    switch (ele) {
      case "special_offers":
        return {
          title: "پیشنهادات ویژه",
          image: window.origin + "/WebSide/assets/images/15.png",
        };
      case "nikotan_offer":
        return {
          title: "تخفیف های نیکوتن",
          image: window.origin + "/WebSide/assets/images/16.png",
        };
      case "spacial_pool":
        return {
          title: "استخرهای ویژه",
          image: window.origin + "/WebSide/assets/images/17.png",
        };
      case "spacial_gym":
        return {
          title: "باشگاه های ویژه",
          image: window.origin + "/WebSide/assets/images/18.png",
        };
      case "spacial_saloon":
        return {
          title: "سالن های ویژه",
          image: window.origin + "/WebSide/assets/images/19.png",
        };
    }
  };
  if (landingLoading) {
    if (window.innerWidth < 1000) {
      return (
        <section className="second-section padding-y-section border-bottom-section border-top-section landing-main-item MainItems">
          <div className="container">
            <div className="row" style={{ borderRadius: "10px" }}>
              <Loading count={1} col={12} height={200} />
            </div>
          </div>
        </section>
      );
    } else {
      return (
        <section className="second-section padding-y-section border-bottom-section border-top-section landing-main-item MainItems">
          <div className="container">
            <div
              className="row justify-content-between"
              style={{ borderRadius: "10px" }}
            >
              <Loading count={1} col={1} height={200} />
              <Loading count={1} col={5} height={200} />
              <Loading count={1} col={5} height={200} />
            </div>
          </div>
        </section>
      );
    }
  }
  if (window.innerWidth < 1000)
    return (
      <section className="second-section padding-y-section border-bottom-section border-top-section landing-main-item MainItems">
        <div className="container">
          <div
            style={{ backgroundColor: "#E42A3F", borderRadius: "10px" }}
            className="d-flex  justify-content-center align-items-center p-1 offer-area"
          >
            {types.map((element, key) => {
              return (
                <div
                  key={key}
                  className={`selector w-100 d-flex justify-content-center  px-1 position-relative ${
                    !(element == types[types.length - 1]) &&
                    "border-right-dashed"
                  }`}
                  style={{ fontSize: "13px", borderRadius: "10px" }}
                >
                  <button
                    className="btn btn-danger w-100"
                    style={{ zIndex: "9999" }}
                    onClick={() => setType(element)}
                  >
                    <div className="p-0 d-flex flex-column justify-content-center align-items-center  ">
                      <span
                        className="pb-1"
                        style={{ fontSize: "12px" }}
                        id="selector-title2"
                      >
                        {renderTypeName(element)["title"]}
                      </span>
                      <img
                        src={renderTypeName(element)["image"]}
                        alt={renderTypeName(element)["title"]}
                        width={"30px"}
                      />
                    </div>
                  </button>
                </div>
              );
            })}
          </div>
          <div className="row">
            <div className="col-12">
              <div className="row text-center header-selector mt-3">
                <h6>{renderTypeName(type)["title"]}</h6>
                <hr />
              </div>
              <RenderSliderMainItem type={type} data={data} />
            </div>
          </div>
        </div>
      </section>
    );
  return (
    <section className="second-section padding-y-section border-bottom-section border-top-section landing-main-item MainItems">
      <div className="container">
        <div className="row">
          <div className="col-1 col-sm-2 d-flex align-items-center">
            <div
              style={{ backgroundColor: "#E42A3F", borderRadius: "10px" }}
              className="d-flex flex-column justify-content-center align-items-center p-1 offer-area"
            >
              {types.map((element, key) => {
                return (
                  <div
                    key={key}
                    className={`selector w-100 d-flex justify-content-center  px-2 py-1 position-relative ${
                      !(element == types[types.length - 1]) && "border-dashed"
                    }`}
                    style={{ fontSize: "13px", borderRadius: "10px" }}
                  >
                    <button
                      style={{ zIndex: "9999" }}
                      onClick={() => setType(element)}
                    >
                      <div className="p-0 d-flex flex-column justify-content-center align-items-center  ">
                        <span className="pb-1" id="selector-title">
                          {renderTypeName(element)["title"]}
                        </span>
                        <img
                          src={renderTypeName(element)["image"]}
                          alt={renderTypeName(element)["title"]}
                          width={"30px"}
                        />
                      </div>
                    </button>
                    {element === type ? (
                      <div
                        className="position-absolute p-0 "
                        style={{ bottom: "20%", left: "-25px", zIndex: "0" }}
                      >
                        <img
                          src={
                            window.origin +
                            "/WebSide/assets/images/flashmain.png"
                          }
                          alt="پیشنهادات ویژه نیکوتن"
                          width={"30px"}
                          style={{ zIndex: "-1" }}
                        />
                      </div>
                    ) : (
                      <></>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
          <div className="col-10 col-sm-10">
            <div className="row text-center header-selector">
              <h6>{renderTypeName(type)["title"]}</h6>
              <hr />
            </div>
            <RenderMainItem type={type} data={data} />
          </div>
        </div>
      </div>
    </section>
  );
};
const Card = ({ data }) => {
  const navigate = useNavigate();

  return (
    <Link
      className="col-md-5 mt-1  p-0 "
      style={{
        cursor: "pointer",
      }}
      to={`${renderItemSinglePath(
        data.category && data.category.id,
        data.city[0] && data.city[0].slug,
        data.slug
      )}`}
    >
      <div className="row new-box-shadow">
        <div className="col p-2 ">
          <div className="d-flex flex-column justify-content-between align-items-start h-100">
            <div className="div">
              <h6
                style={{
                  fontWeight: "500",
                }}
              >
                {data.name}
              </h6>
            </div>
            <div className="d-flex align-items-center">
              <MdLocationPin />
              <p style={{ fontSize: "12px", fontWeight: "400" }}>
                {data.province[0].name} , {data.city[0].name}
              </p>
            </div>
            <div className="d-flex align-items-center mt-1">
              <p
                style={{
                  fontSize: "9px",
                  lineHeight: "15px",
                  fontWeight: "400",
                }}
              >
                <span style={{ fontSize: "12px", marginLeft: "5px" }}>
                  <AiOutlineTag />
                </span>
                {data &&
                  data.tags &&
                  data.tags.map((tag, id) => {
                    if (id < 4)
                      return `${tag.name}${
                        data.tags.length > 4
                          ? id < 3
                            ? " , "
                            : ""
                          : data.tags.length == 1
                          ? ""
                          : id != data.tags.length - 1
                          ? ","
                          : ""
                      } `;
                  })}
              </p>
            </div>
            <div className="d-flex justify-content-between w-100">
              <div className="">
                <RiPriceTag2Line />
                <span
                  style={{
                    fontSize: "12px",
                    marginRight: "5px",
                    fontWeight: "400",
                  }}
                >
                  {data.reserves_count == 0
                    ? Math.floor(Math.random() * (100 - 0 + 1) + 0)
                    : data.reserves_count}{" "}
                  رزرو
                </span>
              </div>
              <div className=" d-flex justify-content-end">
                <p
                  style={{
                    fontWeight: "400",
                  }}
                >
                  {data.comments_avg_score == null
                    ? 5
                    : ~~data.comments_avg_score}
                </p>

                <img
                  src={window.origin + "/WebSide/assets/images/star.png"}
                  alt="امتیاز"
                  style={{ width: "20px", height: "20px" }}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="col p-0 m-0">
          <img
            src={data.images[0]}
            alt={data.name}
            width={"100%"}
            height={"130px"}
            style={{ borderRadius: "10px 0px 0px 10px", objectFit: "fill" }}
          />
        </div>
      </div>
    </Link>
  );
};

const CardSlider = ({ data }) => {
  const navigate = useNavigate();
  return (
    <Link
      to={`/Items/${data.slug}`}
      className="col-12  "
      style={{ direction: "rtl", cursor: "pointer" }}
    >
      <div className="row new-box-shadow">
        <div className="col p-3">
          <div className="d-flex flex-column justify-content-between align-items-start h-100">
            <div className="div">
              <h6>{data.name}</h6>
            </div>
            <div className="d-flex align-items-center">
              <MdLocationPin />
              <p style={{ fontSize: "12px" }}>
                {data.province[0].name} , {data.city[0].name}
              </p>
            </div>
            <div className="d-flex align-items-center mt-1">
              <p style={{ fontSize: "9px", lineHeight: "15px" }}>
                <span style={{ fontSize: "12px", marginLeft: "5px" }}>
                  <AiOutlineTag />
                </span>
                {data &&
                  data.tags &&
                  data.tags.map((tag, id) => {
                    if (id < 4)
                      return `${tag.name}${
                        data.tags.length > 4
                          ? id < 3
                            ? " , "
                            : ""
                          : data.tags.length == 1
                          ? ""
                          : id != data.tags.length - 1
                          ? ","
                          : ""
                      } `;
                  })}
              </p>
            </div>
            <div className="d-flex justify-content-between w-100">
              <div className="">
                <RiPriceTag2Line />
                <span style={{ fontSize: "12px", marginRight: "5px" }}>
                  {data.reserves_count == 0
                    ? Math.floor(Math.random() * (100 - 0 + 1) + 0)
                    : data.reserves_count}{" "}
                  رزرو
                </span>
              </div>
              <div className=" d-flex justify-content-end">
                {data.comments_avg_score == null ? 5 : data.comments_avg_score}
                <img
                  src={window.origin + "/WebSide/assets/images/star.png"}
                  alt="امتیاز"
                  style={{ width: "20px", height: "20px" }}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="col p-0 m-0">
          <img
            src={data.images[0]}
            alt={data.name}
            width={"100%"}
            height={"130px"}
            style={{ borderRadius: "10px 0px 0px 10px", objectFit: "fill" }}
          />
        </div>
      </div>
    </Link>
  );
};
const RenderSliderMainItem = ({ type, data }) => {
  const SampleNextArrow = () => {
    return <div style={{ display: "none" }} />;
  };

  const SamplePrevArrow = () => {
    return <div style={{ display: "none" }} />;
  };
  const settings = {
    dots: true,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    vertical: true,

    verticalSwiping: true,
    autoplay: true,
    speed: 1000,
    initialSlide: 0,
    customPaging: function (i) {
      return <></>;
    },
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
  };
  return (
    <div className="silders row justify-content-evenly">
      <Slider {...settings}>
        {data.map((product, key) => {
          {
            if (type === product.type_item) {
              return <CardSlider data={product} key={key} />;
            }
          }
        })}
      </Slider>
    </div>
  );
};

const RenderMainItem = ({ type, data = [] }) => {
  return (
    <div className="row justify-content-evenly">
      {data.map((product, id) => {
        {
          if (type === product.type_item) {
            return <Card data={product} key={id} />;
          }
        }
      })}
    </div>
  );
};
export default MainItems;
